import axios from 'axios';
import { BASE_URL } from 'utils/constants/Api';

import { IShipmentSearchCriteria } from '@project44-models/shipment-list';

interface ExportFileAsyncPayload {
  email: string;
  searchCriteria: IShipmentSearchCriteria;
}

export const exportFileAsync = (payload: ExportFileAsyncPayload) => {
  return axios.post(`${BASE_URL}/file-export/trigger-async-export`, payload, {
    withCredentials: true,
  });
};
